import { useEffect } from "react";

import { HiOutlineXMark } from "react-icons/hi2";

import "./Modal.css";

export default function Modal({
  isOpen,
  onClose,
  title,
  description,
  children,
  size = "md",
}) {
  /**
   * ESC CLOSE
   */
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);

      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);

      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  /**
   * CLOSED
   */
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal">
      {/* BACKDROP */}
      <div className="modal__backdrop" onClick={onClose} />

      {/* CONTENT */}
      <div className={`modal__content modal__content--${size}`}>
        {/* HEADER */}
        <div className="modal__header">
          <div className="modal__header-content">
            {title && <h2>{title}</h2>}

            {description && <p>{description}</p>}
          </div>

          <button className="modal__close" onClick={onClose}>
            <HiOutlineXMark />
          </button>
        </div>

        {/* BODY */}
        <div className="modal__body">{children}</div>
      </div>
    </div>
  );
}
